<div class="grid min-h-screen lg:grid-cols-2">

    <div class="flex">
        <ng-content></ng-content>
    </div>

    <div class="hidden lg:block">
        <img class="h-full object-cover" src="https://firebasestorage.googleapis.com/v0/b/mce-app-lotppu.appspot.com/o/images%2FcableDrums_Croped.png?alt=media&token=983c7524-565f-4091-a83d-80b194bf3abe" />
    </div>

</div>`
